import { DropdownButton } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { HeadingDesc } from '../../Headings';
import arrowIcon from '../../../assets/images/svg/arrow-down-black.svg';
import arrowRightIcon from '../../../assets/images/svg/arrow-right-blue.svg';
import './loginDropdownBtn.css';

function LoginDropdownBtn(props) {
  const { title } = props;
  const dropDownTitle = () => (
    <div className="loginDropdownContainer">
      <div className="dropDownTitle">
        <HeadingDesc text={<b>{title}</b>} />
      </div>
      <div className="arrowIcon">
        <img src={arrowIcon} alt="arrowIcon" />
      </div>
    </div>
  );
  return (
    <div id="loginDropdown">
      <DropdownButton title={dropDownTitle()}>
        <NavLink className="dropdown-item" to="/">
          HealthCheck & History
          <img src={arrowRightIcon} alt="arrowRightIcon" />
        </NavLink>
        <NavLink className="dropdown-item" to="/">
          Doctor Appointment
          <img src={arrowRightIcon} alt="arrowRightIcon" />
        </NavLink>
        <NavLink className="dropdown-item" to="/">
          Instant Consultation
          <img src={arrowRightIcon} alt="arrowRightIcon" />
        </NavLink>
        <NavLink className="dropdown-item" to="/">
          Medical Records
          <img src={arrowRightIcon} alt="arrowRightIcon" />
        </NavLink>
        <NavLink className="dropdown-item" to="/">
          Family Members
          <img src={arrowRightIcon} alt="arrowRightIcon" />
        </NavLink>
        <NavLink className="dropdown-item" to="/">
          My Profile
          <img src={arrowRightIcon} alt="arrowRightIcon" />
        </NavLink>
        <NavLink className="dropdown-item" to="/">
          Log Out
          <img src={arrowRightIcon} alt="arrowRightIcon" />
        </NavLink>
      </DropdownButton>
    </div>
  );
}

export default LoginDropdownBtn;
